import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAccessToken } from "@/shared/infrastructure/auth/token-storage";
import { LoginPage } from "@/modules/auth/presentation/pages/LoginPage";

export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    if (getAccessToken()) {
      throw redirect({ to: "/" });
    }
  },
  component: LoginPage,
});
